import { formatDate } from '@/utils';
import {
  VStack,
  SimpleGrid,
  Grid,
  GridItem,
  Text,
  Heading,
} from '@chakra-ui/react';
import { format, parseISO } from 'date-fns';

interface Props {
  manager: any;
}

const FormatData = ({ label1, value1, label2, value2 }: any) => {
  return (
    <Grid width="100%" templateColumns="repeat(4, 1fr)" gap={4}>
      <GridItem colSpan={2} textAlign="left" justifyContent="flex-start">
        <Heading as="h6" size="sm" color="#707070">
          {label1}
        </Heading>
        <Text>{value1}</Text>
      </GridItem>
      <GridItem colSpan={2}>
        <Heading as="h6" size="sm" color="#707070">
          {label2}
        </Heading>
        <Text>{value2}</Text>
      </GridItem>
    </Grid>
  );
};

export function ViewManagerInfo({ manager }: Props) {
  return (
    <VStack spacing="4">
      {manager && manager.primeiroAcesso ? (
        <>
          <FormatData
            label1="Email"
            value1={manager && manager.email}
            label2="Celular"
            value2={manager && manager.celular}
          />
          <FormatData
            label1="Código Validação"
            value1={manager && manager.codigoUsuario}
            label2="Criado em"
            value2={manager && formatDate(new Date(manager.dataCriacao))}
          />
        </>
      ) : (
        <>
          <FormatData
            label1="E-mail"
            value1={manager && manager.email}
            label2="Celular"
            value2={manager && manager.celular}
          />
          <FormatData
            label1="CPF"
            value1={manager && manager.cpf}
            label2="Sexo"
            value2={manager && manager.gender[0]?.label}
          />
          <FormatData
            label1="Data de Nascimento"
            value1={manager && manager.dataNascimento}
            label2="Usuário"
            value2={manager && manager.userName}
          />
          <FormatData
            label1="Endereço"
            value1={manager && manager.endereco}
            label2="Número"
            value2={manager && manager.numero}
          />
          <FormatData
            label1="Bairro"
            value1={manager && manager.bairro}
            label2="CEP"
            value2={manager && manager.cep}
          />
          <FormatData
            label1="Cidade"
            value1={manager && manager.cidade}
            label2="Estado"
            value2={manager && manager.estado}
          />

          <div style={{ marginTop: 15 }} />
          {manager?.dataCriacao && (
            <FormatData
              label1="Criado em:"
              value1={manager && formatDate(new Date(manager.dataCriacao))}
              label2="Atualizado em:"
              value2={
                manager?.dataEdicao && formatDate(new Date(manager.dataEdicao))
              }
            />
          )}
        </>
      )}
    </VStack>
  );
}
